export default function PHP_fopen() {
  return (
    <div>
      <h1>PHP_fopen</h1>
    </div>
  );
}
